// extracted by mini-css-extract-plugin
module.exports = {"mobileErrorModal":"f9eOc","desktopErrorModal":"_79cBm"};